import { Layout } from "../components/common/Layout"

function Home() {
  return (
    <Layout>
      <h1>Home</h1>
      <p>
        {" "}
        Is there a recommended way to structure React projects? React doesn’t
        have opinions on how you put files into folders. That said there are a
        few common approaches popular in the ecosystem you may want to consider.
      </p>
      <p>
        Grouping by features or routes One common way to structure projects is
        to locate CSS, JS, and tests together inside folders grouped by feature
        or route.
      </p>
    </Layout>
  )
}

export default Home
